import *as _ from "lodash";
import { ErrorMessage_restate, WarningMessage_restate } from "../PA.Core/Basic/MessageUtils";
import { SnapshotParameterBO } from "./SnapshotParameterBO";
import {
    WB_Snapshot_ParamGLRRow,
    WB_Snapshot_ParamGLELRRow,
    WB_Snapshot_ParamRow,
    WB_Snapshot_ParamPHRRow,
    WB_Snapshot_ParamGLCHRRow, WB_Snapshot_ParamGLPHRRow
} from "../PA.Core/PAdbSchemaRows";
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { PASearch } from "../PA.Core/PASearch";


export class SnapshotParameterBOValidations {

    static async ValidateFields(aBO: SnapshotParameterBO): Promise<void> {
        let snapParamRow: WB_Snapshot_ParamRow = aBO.WB_SnapshotParameter;
        const mp = aBO.ValidateMessageProvider;

        if (!aBO.WB_SnapshotParameter.isActive)
            return;

        // Trade Acccrual Snapshot validations

        if (aBO.WB_SnapshotParameter.cif.PARAM_TYPE == "TradeAccrual") {

            if (!_.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamSARRows, row => row.isActive).length)
                WarningMessage_restate(mp, true, "noSalesAreaInResolution", "The snapshot template is missing the sales area definition in the snapshot scope");


            let bMissingFields: boolean = false;
            let defaultRow = _.first(_.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamGLRRows, aRow => aRow.isActive && aRow.cif.WB_EVTSTYPE_ID == 0));
            if (!_.isEmpty(defaultRow) && (
                defaultRow.cif.PAYMENT_METHOD == "" ||
                defaultRow.cif.GL_EXPENSETYPE_ID == "" ||
                defaultRow.cif.WB_GLACCT_ID_EXPENSE == 0
            )) {
                bMissingFields = true;
            }

            WarningMessage_restate(mp,
                bMissingFields,
                "emptyFields",
                {
                    Title: "GL Accounts Assignments Tab incomplete",
                    Desc: "Fields missing for the 'All Spend Types' row"
                });

            // RTE Allocation - Allocation method
            const defaultRows = _.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamAMRRows, (aRow) => aRow.isDefaultRow && aRow.isActive);
            if (defaultRows.length > 1) {
                ErrorMessage_restate(mp, true, "DuplicateDefault", {
                    Title: "Duplicate default rows exist in Allocation methods table",
                    Desc: "Duplicate default rows exist in Allocation methods table"
                });
            }
            const amrDefaultRow = _.first(defaultRows);
            if (!_.isEmpty(amrDefaultRow)) {
                let bConditionTypeMissing = false;
                if (amrDefaultRow.cif.TIME_ALLOCATION_METHOD.indexOf("LeadTime") !== -1) {
                    if (_.isEmpty(amrDefaultRow.WB_ProductConditionTypeRow) || _.isEmpty(amrDefaultRow.WB_ProductConditionTypeDefaultRow)) {
                        bConditionTypeMissing = true;
                    }
                }
                let bAmrDefaultRowMissingField = false;
                if (amrDefaultRow.cif.RATE_BASIS_ID === "" ||
                    (amrDefaultRow.cif.PRODUCT_ALLOCATION_METHOD === "" && aBO.WB_SnapshotParameter.cif.SOURCE_LEVEL == "Allocate") ||
                    (amrDefaultRow.cif.TIME_ALLOCATION_METHOD === "" && aBO.WB_SnapshotParameter.cif.SOURCE_LEVEL == "Allocate") ||
                    (amrDefaultRow.cif.COST_RECOGNITION_DATES === "" && aBO.WB_SnapshotParameter.cif.SOURCE_LEVEL == "Allocate") ||
                    bConditionTypeMissing
                ) {
                    bAmrDefaultRowMissingField = true;
                }
                WarningMessage_restate(mp, bAmrDefaultRowMissingField, "AMREmptyFields", {
                    Title: "Tactic Allocations - Missing configuration",
                    Desc: `Missing configuration in the Allocation methods table: All fields must be filled for the "All Spend Types" row`
                });
            }

            //GL Accounts Assignment Tab
            let snapshotParamGLELRelRows: WB_Snapshot_ParamGLELRRow[] = _.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamGLELRRows, aGLELRow => aGLELRow.isActive);
            let emptyLiabilityId = _.filter(snapshotParamGLELRelRows, aGLELRow => aGLELRow.cif.WB_GLACCT_ID_LIABILITY == 0);
            if (emptyLiabilityId.length > 0) {
                WarningMessage_restate(mp, true, "MissingLiabilityRel", {
                    Title: "Expense account is missing a liability account relationship ",
                    Desc: `Missing configuration in the Expense and Liability Accounts Relationship table: Liability Account cannot be empty`
                });
            }

            //check for duplicate rows
            let activeGLRRows: WB_Snapshot_ParamGLRRow[] = _.filter(aBO.WB_SnapshotParameter.WB_Snapshot_ParamGLRRows, aGLRow => aGLRow.isActive);
            let uniqRows = _.uniqWith(
                activeGLRRows,
                (aRowA, aRowB) =>
                    aRowA.cif.WB_EVTSTYPE_ID === aRowB.cif.WB_EVTSTYPE_ID &&
                    aRowA.cif.WB_FUNDTYPE_ID === aRowB.cif.WB_FUNDTYPE_ID &&
                    aRowA.cif.WB_GLACCT_ID_EXPENSE === aRowB.cif.WB_GLACCT_ID_EXPENSE &&
                    aRowA.cif.PAYMENT_METHOD === aRowB.cif.PAYMENT_METHOD
            );
            if (uniqRows.length != activeGLRRows.length) {
                ErrorMessage_restate(mp, true, "DuplicateRel", {
                    Title: "Duplicate rows existing in Spend Accounts Table ",
                    Desc: `Duplicate rows existing in Spend Accounts Table `
                });
            }

            //check Scope Tab
            let bScopeTabIncomplete = false;
            if (snapParamRow.cif.PLANNING_YEAR_IND == "1") {
                if (snapParamRow.cif.WB_PERIOD_ID_PLANNING_YEAR == 0) {
                    bScopeTabIncomplete = true;
                }
            }

            if (snapParamRow.cif.DATE_RANGE_IND == "1") {
                if (snapParamRow.cif.EFFECTIVE_END_DT == "" || snapParamRow.cif.EFFECTIVE_START_DT == "") {
                    bScopeTabIncomplete = true;
                }
            }

            if (snapParamRow.cif.SELECT_TACTICS_IND == "1") {
                if (snapParamRow.cif.WB_EVTSTYPE_ID_CSV == "") {
                    bScopeTabIncomplete = true;
                }
            }

            if (snapParamRow.cif.EVENT_STATUS_CSV == "")
                bScopeTabIncomplete = true;

            if (snapParamRow.cif.TACTIC_STATUS_CSV == "")
                bScopeTabIncomplete = true;

            if (bScopeTabIncomplete)
                WarningMessage_restate(mp, true, "ScopeTab", {
                    Title: "Scope Tab Incomplete.",
                    Desc: `There are missing fields on the scope tab.`
                });

            //Check Snapshot Resolution Tab
            if (snapParamRow.cif.WB_ENTITY_ID_PRODUCT_SNP == 0 || snapParamRow.cif.WB_ENTITY_ID_PERIOD == 0) {
                WarningMessage_restate(mp, true, "SnapResolutionTab", {
                    Title: "Snapshot Resolution Tab Incomplete.",
                    Desc: `There are missing fields on the snapshot resolution tab.`
                });
            }

            //GL Posting Level Tab
            if (snapParamRow.cif.WB_ENTITY_ID_CUSTOMER == 0 || snapParamRow.cif.WB_ENTITY_ID_PRODUCT == 0) {
                WarningMessage_restate(mp, true, "GLPostingTab", {
                    Title: "GL Posting Level Tab Incomplete.",
                    Desc: `There are missing fields on the GL Posting Level tab.`
                });
            }

            //Main Hierarchy Tab
            if (snapParamRow.cif.GLH_SALESAREA_IND !== "1") {
                if (snapParamRow.cif.WB_CUSTH_ID_GL == 0 || snapParamRow.cif.WB_PRDH_ID_GL == 0) {
                    WarningMessage_restate(mp, true, "MainHierarchyTab", {
                        Title: "Main Hierarchy Tab Incomplete.",
                        Desc: `There are missing fields on the Main Hierarchy tab.`
                    });
                }
            } else {
                let bMainHierarchyEmpty = false;

                let custBySARows: WB_Snapshot_ParamGLCHRRow[] = _.filter(snapParamRow.WB_Snapshot_ParamGLCHRRows, aRow => aRow.isActive);
                _.forEach(custBySARows, (aRow: WB_Snapshot_ParamGLCHRRow) => {
                    if (aRow.cif.WB_CUSTH_ID <= 0) {
                        bMainHierarchyEmpty = true;
                    }
                });

                let prdBySARows: WB_Snapshot_ParamGLPHRRow[] = _.filter(snapParamRow.WB_Snapshot_ParamGLPHRRows, aRow => aRow.isActive);
                _.forEach(prdBySARows, (aRow: WB_Snapshot_ParamGLPHRRow) => {
                    if (aRow.cif.WB_PRDH_ID <= 0) {
                        bMainHierarchyEmpty = true;
                    }
                });

                if (bMainHierarchyEmpty)
                    WarningMessage_restate(mp, true, "MainHierarchyTab", {
                        Title: "Main Hierarchy Tab Incomplete.",
                        Desc: `There are missing fields on the Main Hierarchy tab.`
                    });
            }

            //Other Allocations Tab
            let activePHRRows: WB_Snapshot_ParamPHRRow[] = _.filter(snapParamRow.WB_Snapshot_ParamPHRRows, aRow => aRow.isActive);
            let bOtherTabIncomplete = false;
            let bShowSalesArea = snapParamRow.cif.SNH_SALESAREA_IND;
            if (bShowSalesArea == "1")
                activePHRRows = _.filter(activePHRRows, (a) => a.cif.WB_SALESAREA_ID > 0);
            else
                activePHRRows = _.filter(activePHRRows, (a) => a.cif.WB_SALESAREA_ID == 0);

            _.forEach(activePHRRows, (aRow: WB_Snapshot_ParamPHRRow) => {
                if (aRow.cif.WB_PRDH_ID <= 0) {
                    bOtherTabIncomplete = true;
                }
            });

            if (bOtherTabIncomplete)
                WarningMessage_restate(mp, true, "ScopeTab", {
                    Title: "Other Allocations Tab Incomplete.",
                    Desc: `There are missing fields on the other allocations tab.`
                });
        }
    }

    static async ValidateDelete(aBO: SnapshotParameterBO): Promise<void> {
        aBO.DeleteMessageProvider.clearMessages();

        let userContext = PAEnvironment.getValue(PAEnvironment.UserContext, "UserContext");
        let bHasRole = userContext.hasRoleId("Snapshot_Manager");

        if (!bHasRole) {
            aBO.DeleteMessageProvider.addMessage({
                code: "deleteRole",
                type: MessageType.Error,
                title: "The template cannot be deleted, due to user role restrictions",
                description: "The template cannot be deleted, due to user role restrictions. Only Users with Snapshot Manager Role can delete a Snapshot Template"
            });
            return;
        } else {
            aBO.ValidateMessageProvider.removeMessage("deleteRole");
        }

        let arrSnapshots = await PASearch.find("vUI_Processed_Snapshots",
            {
                where: {
                    WB_SNAPSHOT_PARAM_ID: aBO.drWB_SnapshotParameter.cif.WB_SNAPSHOT_PARAM_ID
                }
            },
            {
                WB_SNAPSHOT_PARAM_ID: { type: "number" }
            },
            [],
            0,
            ["WB_SNAPSHOT_ID"]);

        if (arrSnapshots.length > 0) {
            aBO.DeleteMessageProvider.addMessage({
                code: "snapshotsExist",
                type: MessageType.Error,
                title: "The template cannot be deleted, since snapshots using this template have already been processed.",
                description: "The template cannot be deleted, since snapshots using this template have already been processed."
            });
            return;
        } else {
            aBO.ValidateMessageProvider.removeMessage("snapshotsExist");
        }

    }
}
